module.exports = __webpack_public_path__ + "img/logo3.e7bcbb5f.png";